<template>
  <Field
    as="div"
    :name="name || ''"
    type="radio"
    :rules="rules"
    v-slot="{ field, errorMessage, value }"
    :model-value="modelValue"
  >
    <div class="relative w-full flex items-center gap-2">
      <input
        type="radio"
        v-bind="field"
        :id="id"
        :name="name"
        :value="value"
        :disabled="disabled"
        :readonly="readonly"
        :required="required"
        class="absolute opacity-0 w-0 h-0"
      />

      <label :for="id" class="flex items-center cursor-pointer select-none">
        <span
          :class="[
            'w-7 h-7 flex items-center justify-center bg-surface-light border rounded-full transition-colors',
            field.checked ? 'border-primary' : 'border-input-border',
            disabled ? 'opacity-50 cursor-not-allowed' : '',
          ]"
        >
          <span
            v-if="field.checked"
            class="block w-3 h-3 rounded-full bg-primary"
          ></span>
        </span>
        <span :class="['ml-2', errorMessage ? 'text-error' : 'text-text']">{{
          label
        }}</span>
      </label>
    </div>
    <div
      v-if="errorMessage && !hideError"
      class="text-sm block mt-2 pb-2 text-error"
    >
      {{ errorMessage }}
    </div>
  </Field>
</template>

<script setup lang="ts">
  import { Field } from 'vee-validate';

  import { type InputProps } from './InputMixin';

  interface Props extends InputProps<string> {
    label?: string;
    hideError?: boolean;
    required?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    modelValue: undefined,
  });
</script>
